<template>
  <div id="app" style="overflow: auto;">
    <router-view v-wechat-title='$route.meta.title' />
  </div>
</template>
<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant'
import VueCookies from 'vue-cookies'

Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(VueCookies)
export default {
  data () {
    return {
      token: ''
    }
  },
  created () {
    var query = this.$route.query
    const cookiesToken = this.$cookies.get('token')
    this.token = query.token
    const isTokenChange = this.token != null && this.token !== cookiesToken
    if (isTokenChange) {
      this.$cookies.set('token', this.token, '30d')
      this.$cookies.remove('logoPath')
      this.$cookies.remove('companyname')
      this.$cookies.remove('openid')
    }
    const openId = this.$cookies.get('openid')
    if (openId == null || isTokenChange) {
      // const redirectUri = 'http://localhost:9001/index/home'
      // const redirectUri = 'http://zhuhai.nat300.top/index/home'
      const redirectUri = 'https://busmoile.wisewatercloud.com/index/home'
      // 获取openId
      this.StringUtil.getOpenId(this, redirectUri, this.$cookies.get('token'), query.code, query.openId)
    }
    // this.pathTheme = './assets/less/myTheme.less'
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover' },
      { name: 'format-detection', content: 'telephone=no' },
      { name: 'format-detection', content: 'email=no' },
      { name: 'x5-orientation', content: 'landscape' },
      { name: 'screen-orientation', content: 'landscape' }
    ]
  }
}
</script>

<style>
  html {
    background-color: #F1F2F6;
  }
  html,body{
    height: 100vh;
    overflow: hidden;
  }
  #app {
    height: 100vh;
  }
  pre {
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .margin-top-10 {
    margin-top: 10px;
  }
</style>
